import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FirebaseContext } from '../../context/firebase';
import defaultUser from '../../assets/defaultUser.png';
import './Profile.css';
import { makeStyles, TextField } from '@material-ui/core';

function Profile() {
	const { uid } = useParams();
	const { firebase } = useContext(FirebaseContext);
	const [profileData, setProfileData] = useState();
	const [edit, setEdit] = useState(false);

	const [formData, setFormData] = useState({
		fullName: '',
		email: '',
		telNumber: '',
		password: '',
		confirmPassword: '',
	});

	const { fullName, email, telNumber, password, confirmPassword } = formData;

	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	useEffect(() => {
		try {
			var profileObj;

			firebase
				.database()
				.ref('/users/' + uid)
				.on('value', (snapshot) => {
					console.log('Snapshot: ' + snapshot);
					var fullName = snapshot.val().fullName;
					var email = snapshot.val().email;
					var phoneNumber = snapshot.val().telNumber;
					var userType = snapshot.val().userType;

					profileObj = {
						fullName: fullName,
						email: email,
						phoneNumber: phoneNumber,
						userType: userType,
					};

					setProfileData(profileObj);
				});
		} catch (error) {
			console.error('Profile Error: ', error);
		}
	}, []);

	const useStyles = makeStyles({
		textField: {
			width: '40%',

			'&input:disabled': {
				color: '#000000',
			},
		},
	});

	const handleClickEdit = () => {
		setEdit(true);
	};
	const handleClickBack = () => {
		setEdit(false);
	};

	const handleEdit = (e) => {
		e.preventDefault();
		var userRef = firebase.database().ref('/users/' + uid);

		if (fullName === '' || telNumber === '') {
			setError('Please fill in all the fields.');
			setTimeout(() => setError(''), 3000);
		} else {
			userRef.update({
				fullName: fullName,
				email: email,
				telNumber: telNumber,
				displayName: fullName,
			});
			setSuccess('Edit Profile successfully.');
			setTimeout(() => setSuccess(''), 3000);
		}
	};

	const styles = useStyles();
	return (
		<div className='profile-page'>
			<h2 id='profile-title'>Profile</h2>

			<div className='profile-header'>
				<div className='profile-picture-circle'>
					<img
						src={defaultUser}
						alt='Profile Picture'
						title='Profile Picture'
					/>
				</div>
				<div className='profile-header-info'>
					<h1 className='profile-name'>{profileData?.fullName}</h1>
					<p className='profile-small-text'>
						{profileData?.email}
						<span> - {profileData?.userType}</span>
					</p>
				</div>
			</div>

			<div className='account-body-header'>
				<h2 className='account-section'>Account </h2>
			</div>

			{firebase.auth().currentUser.uid === uid && (
				<>
					{edit ? (
						<div className='profile-edit-button' onClick={handleClickBack}>
							<p>Back</p>
						</div>
					) : (
						<div className='profile-edit-button' onClick={handleClickEdit}>
							<p>Edit Profile</p>
						</div>
					)}
				</>
			)}

			<hr className='separator' />

			<div className='account-form'>
				{edit ? (
					<>
						<form
							onSubmit={handleEdit}
							method='POST'
							autoComplete='off'
						>
							{error && <p className='form-error'>{error}</p>}
							{success && <p className='form-success'>{success}</p>}
							<div className='form-group'>
								<label htmlFor='fullName'>Full Name</label>
								<TextField
									type='text'
									name='fullName'
									placeholder={profileData?.fullName}
									value={fullName}
									autoComplete={'off'}
									className={styles.textField}
									onChange={(e) => onChange(e)}
								/>
							</div>
							<div className='form-group'>
								<label htmlFor='phoneNumber'>Phone Number</label>
								<TextField
									type='tel'
									inputProps={{ pattern: '[0-9]{3}[0-9]{3}[0-9]{4}' }}
									name='telNumber'
									placeholder={profileData?.phoneNumber}
									value={telNumber}
									className={styles.textField}
									autoComplete={'off'}
									onChange={(e) => onChange(e)}
								/>
							</div>

							<input
								type='submit'
								className='editBtn btn btn-primary'
								value='Edit Profile'
							/>
						</form>
					</>
				) : (
					<>
						<div className='form-group'>
							<label htmlFor='fullName'>Full Name</label>
							<TextField
								type='text'
								name='fullName'
								placeholder={profileData?.fullName}
								value={profileData?.fullName}
								autoComplete='off'
								disabled
								className={styles.textField}
								onChange={(e) => onChange(e)}
							/>
						</div>

						<div className='form-group'>
							<label htmlFor='phoneNumber'>Phone Number</label>
							<TextField
								type='tel'
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='telNumber'
								placeholder={profileData?.phoneNumber}
								value={profileData?.phoneNumber}
								className={styles.textField}
								autoComplete='off'
								disabled
								onChange={(e) => onChange(e)}
							/>
						</div>
					</>
				)}
			</div>
		</div>
	);
}

export default Profile;
